/**
 * EMR Data API
 * Handles fetching and saving EMR form data (summary section fields)
 */

import { apiClient } from './config';

/**
 * Fetch all EMR data for a patient
 */
export const fetchEMRData = async (patientId) => {
  const response = await apiClient.get(`/emr/${patientId}`);
  return response.data;
};

/**
 * Save EMR form data (partial update supported — send only changed fields)
 */
export const saveEMRData = async (patientId, data) => {
  const payload = { patientId, ...data };
  const response = await apiClient.post('/emr', payload);
  return response.data;
};
